import React from "react";
import "./App.scss";
import { preloadFirestore, SuspenseWithPerf } from "reactfire";
import Routes from "./screens/Routes";
import Loading from "./screens/loading/Loading";
import AppProviders from "./AppProviders";

function App() {
  preloadFirestore({
    setup: (firestore) =>
      firestore().enablePersistence({ synchronizeTabs: true }),
  });

  return (
    <SuspenseWithPerf fallback={<Loading />} traceId={"load-application"}>
      <AppProviders>
        <Routes />
      </AppProviders>
    </SuspenseWithPerf>
  );
}

export default App;
